import React, { useEffect, useState } from "react";
import DataTable from "./Components/DataTable";
import axios from "axios";
import { Config } from "../../../../../Config";

const Skills = (props) => {
  const [PageData, setPageData] = useState();
  const [TotalElements, setTotalElements] = useState(0);
  const [Pages, setPages] = useState([]);
  const [PageInfo, setPageInfo] = useState({
    FirstPage: 1,
    FirstDotsShown: false,
    MiddlePage: 3,
    LastDotsShown: false,
    LastPage: 7,
    ActivePage: 1,
  });

  //lifecycle method (equal to ComponentDidMount)
  useEffect(() => {
    fetchHistory(0);
    updatePagination();
  }, [TotalElements]);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const updatePagination = () => {
    let Count = Math.ceil(TotalElements / 10);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };
  const fetchHistory = (Start) => {
    let APIData = {
      size: 10,
      sorts: [
        {
          direction: "DESC",
          fieldName: "updatedTime",
        },
      ],
      start: Start,
    };

    if (
      document.getElementById("File Name-pointer-up").classList.length > 1 ||
      document.getElementById("File Name-pointer-down").classList.length > 1
    ) {
      APIData.sorts[0].fieldName = "fileName";
      if (
        document.getElementById("File Name-pointer-up").classList.length > 1
      ) {
        APIData.sorts[0].direction = "ASC";
      }
      if (
        document.getElementById("File Name-pointer-down").classList.length > 1
      ) {
        APIData.sorts[0].direction = "DESC";
      }
    } else {
      APIData.sorts[0].fieldName = "updatedTime";
      if (
        document.getElementById("Transfer Date-pointer-up").classList.length > 1
      ) {
        APIData.sorts[0].direction = "ASC";
      } else {
        APIData.sorts[0].direction = "DESC";
      }
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/skill-module/history",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: APIData,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setTotalElements(Res.data.totalElements);
        createPagination(Res.data.totalElements);
        setPageData(Res.data.results);
        if (Res.data.totalElements < 10) {
          document
            .getElementById("next-page")
            .classList.add("page-btn-disabled");
          document
            .getElementById("prev-page")
            .classList.add("page-btn-disabled");
          document.getElementById("end").innerHTML = Res.data.totalElements;
        }
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const createPagination = (TotalCount) => {
    let Count = Math.ceil(TotalCount / 10);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    updatePagination();
  };
  const shortenPagination = (Pages) => {
    if (Pages.length > 0) {
      let LastPage = Pages.reduce((a, b) => {
        return Math.max(a, b);
      });
      let FirstPage = parseInt(Pages[0]);
      let MiddlePage = 3;
      let FirstDotsShown = false;
      let LastDotsShown = true;
      let ActivePage;

      for (let i = 1; i <= Pages.length; i++) {
        if (document.getElementById(i + "-page-btn") !== null) {
          if (
            document
              .getElementById(i + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePage = i;
          }
        }
      }
      if (ActivePage < 3) {
        LastDotsShown = true;
      }
      if (ActivePage > 3) {
        FirstDotsShown = true;
        MiddlePage = ActivePage;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      if (ActivePage < MiddlePage && ActivePage > 3) {
        FirstDotsShown = true;
        LastDotsShown = true;
      }
      if (parseInt(LastPage - 3) >= ActivePage) {
        LastDotsShown = false;
      }
      if (ActivePage === 3) {
        FirstDotsShown = false;
        MiddlePage = 3;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      setPageInfo({
        FirstPage: FirstPage,
        FirstDotsShown: FirstDotsShown,
        MiddlePage: MiddlePage,
        LastDotsShown: LastDotsShown,
        LastPage: LastPage,
        ActivePage: ActivePage,
      });
    } else {
      setPageInfo({
        FirstPage: 1,
        FirstDotsShown: false,
        MiddlePage: 3,
        LastDotsShown: true,
        LastPage: 1,
        ActivePage: 1,
      });
    }
  };
  const updateActiveClass = (PageNumber) => {
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        document
          .getElementById(i + "-page-btn")
          .classList.remove("active-page");
      }
    }
    document
      .getElementById(PageNumber + "-page-btn")
      .classList.add("active-page");
  };

  const requestPageNumber = (PageNumber) => {
    let NewStart = parseInt((PageNumber - 1) * 10);

    fetchHistory(NewStart);

    if (NewStart === 0) {
      document.getElementById("start").innerHTML = 1;
    } else {
      document.getElementById("start").innerHTML = NewStart;
    }
    if (NewStart + 10 > TotalElements) {
      let Difference = parseInt(TotalElements - NewStart);
      document.getElementById("end").innerHTML = parseInt(
        NewStart + Difference
      );
      document.getElementById("next-page").classList.add("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    } else {
      document.getElementById("end").innerHTML = parseInt(NewStart + 10);
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
    if (PageNumber === 1) {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    }
    updateActiveClass(PageNumber);
  };

  const requestNextPage = () => {
    let NextPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (
        document.getElementById(i + "-page-btn") !== null &&
        document.getElementById(i + "-page-btn").classList.length > 1
      ) {
        NextPage = parseInt(i + 1);
      }
    }
    document.getElementById(NextPage + "-page-btn").click();
  };
  const requestPrevPage = () => {
    let PrevPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (
        document.getElementById(i + "-page-btn") !== null &&
        document.getElementById(i + "-page-btn").classList.length > 1
      ) {
        if (i === 1) {
          PrevPage = 1;
        } else {
          PrevPage = parseInt(i - 1);
        }
      }
    }
    document.getElementById(PrevPage + "-page-btn").click();
  };

  const filterByName = () => {
    for (let i = 1; i <= Pages.length; i++) {
      if (
        document.getElementById(i + "-page-btn") !== null &&
        document.getElementById(i + "-page-btn").classList.length > 1
      ) {
        fetchHistory(parseInt((i - 1) * 10));
      }
    }
  };

  const filterByDate = () => {
    for (let i = 1; i <= Pages.length; i++) {
      if (
        document.getElementById(i + "-page-btn") !== null &&
        document.getElementById(i + "-page-btn").classList.length > 1
      ) {
        fetchHistory(parseInt((i - 1) * 10));
      }
    }
  };

  return (
    <div className="main-content ai ai-history">
      <DataTable
        Data={PageData}
        FilterByFileName={() => filterByName()}
        FilterByDate={() => filterByDate()}
        LangData={props.LangData}
      />
      <section className="history-footer">
        <span>
          {translateText("showing")} <p id="start">1</p>
          {translateText("to")} <p id="end">10</p>
          {translateText("of")} {TotalElements} {translateText("items")}.
        </span>
        <section className="pagination-holder">
          <button
            onClick={() => requestPrevPage()}
            id="prev-page"
            className="page-btn page-btn-disabled"
          >
            <i className="feather-chevron-left"></i>
          </button>
          <React.Fragment>
            {Pages.length < 6 ? (
              <React.Fragment>
                {Pages.map((Page) => (
                  <React.Fragment>
                    {Page === 1 ? (
                      <button
                        key={Page}
                        onClick={() => requestPageNumber(Page)}
                        className="page-btn active-page"
                        id={Page + "-page-btn"}
                      >
                        {Page}
                      </button>
                    ) : (
                      <button
                        key={Page}
                        onClick={() => requestPageNumber(Page)}
                        className="page-btn"
                        id={Page + "-page-btn"}
                      >
                        {Page}
                      </button>
                    )}
                  </React.Fragment>
                ))}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <button
                  onClick={() => requestPageNumber(1)}
                  className="page-btn active-page"
                  id={1 + "-page-btn"}
                >
                  {1}
                </button>
                {PageInfo.FirstDotsShown ? <p>...</p> : null}
                <button
                  onClick={() =>
                    requestPageNumber(parseInt(PageInfo.MiddlePage - 1))
                  }
                  className="page-btn"
                  id={parseInt(PageInfo.MiddlePage - 1) + "-page-btn"}
                >
                  {parseInt(PageInfo.MiddlePage - 1)}
                </button>
                {PageInfo.MiddlePage === PageInfo.LastPage ? null : (
                  <button
                    onClick={() => requestPageNumber(PageInfo.MiddlePage)}
                    className="page-btn"
                    id={PageInfo.MiddlePage + "-page-btn"}
                  >
                    {PageInfo.MiddlePage}
                  </button>
                )}
                {parseInt(PageInfo.MiddlePage + 1) >=
                PageInfo.LastPage ? null : (
                  <button
                    onClick={() =>
                      requestPageNumber(parseInt(PageInfo.MiddlePage + 1))
                    }
                    className="page-btn "
                    id={parseInt(PageInfo.MiddlePage + 1) + "-page-btn"}
                  >
                    {parseInt(PageInfo.MiddlePage + 1)}
                  </button>
                )}
                {!PageInfo.LastDotsShown ? <p>...</p> : null}
                <button
                  onClick={() => requestPageNumber(PageInfo.LastPage)}
                  className="page-btn"
                  id={PageInfo.LastPage + "-page-btn"}
                >
                  {PageInfo.LastPage}
                </button>
              </React.Fragment>
            )}
          </React.Fragment>
          <button
            onClick={() => requestNextPage()}
            id="next-page"
            className="page-btn"
          >
            <i className="feather-chevron-right"></i>
          </button>
        </section>
      </section>
    </div>
  );
};
export default Skills;
